export const setCurrentFlow = (currentFlow) => {
  return (dispatch) => {
    dispatch({ type: 'SET_CURRENT_FLOW', payload: { currentFlow: currentFlow } })
  }
}

export const toggleTypesStepView = () => {
  return (dispatch) => {
    dispatch({ type: 'TOGGLE_TYPES_STEP_VIEW' })
  }
}
